import React from 'react';
import VariantSwatch from './variant-swatch';
import { StoreAppAPI } from '../../../core/src/storeapp-api-client';
import { ValidationControl } from '../../../context/validation/validation-context';
import withPrices from '../../../product/components/product-price/with-product-price';

class VariantSwatchContainer extends React.Component {
	state = {
		currSlug: null,
		skus: [],
		fetchedProducts: {}
	}
	_isMounted = true;

	componentDidMount(){
		const skus = this.populateVariantSkus();
		this.fetchVariants(skus);
	}

	componentDidUpdate(prevProps, prevState) {
		const { product: prevProduct } = prevProps;
		const { product } = this.props;

		//if product changed and product is not one of the variants fetch new variants
		if(prevProduct.sku !== product.sku){
			const skus = this.populateVariantSkus();
			!skus.includes(product.sku) && this.fetchVariants(skus);
		}
	}

	componentWillUnmount(){
		this._isMounted = false;
	}

	populateVariantSkus = () => this.props.product.variants.reduce((r, variant)=>{
		if(!variant.disabled && variant.product){
			r.push(variant.product.sku)
		}
		return r;
	},[]);

	fetchVariants = (skus) => {
		let storeAppAPI = new StoreAppAPI();
		let fetchedProducts = {};
		let ids = [];
		storeAppAPI.product.variants(skus).then(({status, data}) => {
			if (status == "200" && data) {
				data.forEach(variant=>{
					fetchedProducts[variant._id] = variant;
					if(variant.hasOwnProperty("itemId")){
						ids.push(variant.itemId);
					}
				});
				this.props.fetchPrices(ids);
				if(this._isMounted)this.setState({ skus, fetchedProducts });
			}
		});
	}

	render(){
		const { skus, fetchedProducts } = this.state;
		return(
			<ValidationControl>
				{
					(validationContext)=>
						<VariantSwatch
							fetchedProducts={ fetchedProducts }
							variantSkus={skus}
							validationContext={validationContext}
							{...this.props}
						/>
				}
			</ValidationControl>
		)
	}
}

export default withPrices(VariantSwatchContainer);
